<template>
  <div>
    <div class="simple-service__section">
      <div class="simple-service__title">{{$t('simpleService.location.title')}}</div>
      <div v-if="loading">
        <spinner size="18" class="spinner spinner--select"></spinner>
      </div>
      <div v-else>
        <div class="location--name">{{location.name}}</div>
        <div class="location--region">{{location.addressLabel}}</div>
        <div>
          {{$t('simpleService.location.telephoneLabel')}}: <a :href="telephoneHref">{{telephoneNum}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'vue-simple-spinner';

export default {
  name: 'WorkshopDetails',
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('location', ['location']),
    telephoneNum() {
      if (this.location.locationPropertyMap && this.location.locationPropertyMap.CENTRAL_PHONE) {
        return this.location.locationPropertyMap.CENTRAL_PHONE[0].value;
      } else {
        return ''
      }
    },
    telephoneHref() {
      return `tel:${this.telephoneNum}`;
    }
  },
  components: {
    Spinner
  },
  created () {
    this.loading = true;
    this.$store.dispatch('location/getLocation')
      .finally(() => {
        this.loading = false;
      });
  }
}
</script>
